import { render } from "./NewViewFilter.vue?vue&type=template&id=13a19020"
import script from "./NewViewFilter.vue?vue&type=script&lang=js"
export * from "./NewViewFilter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__